import { render, staticRenderFns } from "./avatar-crop.vue?vue&type=template&id=792c985e&"
import script from "./avatar-crop.vue?vue&type=script&lang=js&"
export * from "./avatar-crop.vue?vue&type=script&lang=js&"
import style0 from "./avatar-crop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports